export function getFileIconByExtension(ext) {
  let icon = '';
  const formattedExt = ext.toLowerCase();

  if (['rtf', 'docx', 'doc'].includes(formattedExt) || formattedExt.includes('word')) {
    icon = 'file_word';
  } else if (['xls', 'xlsx', 'xlsxm'].includes(formattedExt) || formattedExt.includes('spreadsheet')) {
    icon = 'file_excel';
  } else if (['ppttf', 'pptx', 'ppsx'].includes(formattedExt) || formattedExt.includes('presentation')) {
    icon = 'file_power_point';
  } else if (['pdf', 'pdfa'].includes(formattedExt)) {
    icon = 'file_pdf';
  } else if (['jpg', 'jpeg', 'bmp', 'png'].includes(formattedExt)) {
    icon = 'file_picture';
  } else if (['gif'].includes(formattedExt)) {
    icon = 'file_pdf';
  } else if (['zip', '7z', 'rar', 'gz'].includes(formattedExt)) {
    icon = 'file_archive';
  } else {
    icon = 'file_other';
  }

  return icon;
}
